<div class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line">
      <div class="ir-line-content"><span>Create folder</span></div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-content--modal th-content">
      <table class="ir-modal-table">
        <tr>
          <td class="margin-big">
            <h2><span>Name</span></h2>
          </td>
          <td class="margin-big">
            <div class="ir-form-group">
              <input class="ir-form-set" [(ngModel)]="name" placeholder="Folder name" type="text" required />
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
          <span>Cancel</span>
        </div>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <button
          class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
          (click)="createFolder()"
          [disabled]="!name"
        >
          <span>Create</span>
        </button>
      </div>
    </div>
  </div>
</div>
